import { useState } from "react";

import { getPersonRelation } from "@lib/logic";
import {
  acceptConnection,
  getConnectedUserById,
  getConnectionById,
  sendConnection,
  useAppDispatch,
  useAppSelector,
  withAsyncThunkErrorHandling,
} from "@lib/store";

// How the viewer relates to a person, and how to connect: send the person a request, or accept the person's request
export const usePersonConnection = (userId: string) => {
  const dispatch = useAppDispatch();
  const [isSending, setIsSending] = useState(false);

  // The connected users also hold pending requests, so the connection's status says whether they're connected
  const connection = useAppSelector(state => {
    const connectionId = getConnectedUserById(state, userId)?.connectionId;

    return connectionId ? getConnectionById(state, connectionId) : undefined;
  });

  const connect = async () => {
    setIsSending(true);

    await dispatch(withAsyncThunkErrorHandling(() => sendConnection({ userId })));

    setIsSending(false);
  };

  const accept = async () => {
    if (!connection) return;

    setIsSending(true);

    await dispatch(withAsyncThunkErrorHandling(() => acceptConnection({ connectionId: connection.id, userId })));

    setIsSending(false);
  };

  return {
    relation: getPersonRelation(connection),

    isSending,

    connect,

    accept,
  };
};
